import LoginStore from './LoginStore';
import ThemeStore from './ThemeStore';
import DeskTopStore from './DeskTopStore';
import IntroStore from './IntroStore';

const portalLoginStore = new LoginStore();
const portalThemeStore = new ThemeStore();
const portalDeskTopStore = new DeskTopStore();
const portalIntroStore = new IntroStore();

export default {
    portalLoginStore,
    portalThemeStore,
    portalDeskTopStore,
    portalIntroStore
};




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/stores/index.js